import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface DeleteProformaType {
  oidLiquidacionWeb: number;
  oidProForma: number[];
}

export const deleteProforma = async (
  query: DeleteProformaType
): Promise<boolean> => {
  try {
    const promises = query.oidProForma.map((oidProForma) =>
      apiClient.post<ApiResponse<string>>(Endpoints.Depo20QuitarProforma, {
        oidLiquidacionWeb: query.oidLiquidacionWeb,
        oidProForma,
      })
    );
    const res = await Promise.all(promises);

    return res.every((response) => response.data.value !== undefined);
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
